<template>
  <div v-if="$route.name == 'Modificaciones'">
    <page-header :breadcrumRoutes="routesHeader" title="Modificaciones">
      <template #buttons>
        <a-button type="primary" @click="showModal">
          Crear modificación
        </a-button>
      </template>
    </page-header>

    <table-resume type="Modificacion" />

    <a-card class="mt-2">
      <a-row type="flex" justify="space-between" align="middle">
        <a-col>
          <a-row class="mt-2">
            <a-typography-title :level="4" class="text-gray-8 mr-5">
              Stock modificaciones
            </a-typography-title>
            <a-radio-group :value="ticketsTypeSelection" @change="onChangeTabs">
              <a-radio-button
                style="margin: 1px; z-index: 0"
                value="individual"
              >
                Individuales
              </a-radio-button>
              <a-radio-button value="masiva">Masivas</a-radio-button>
            </a-radio-group>
          </a-row>
        </a-col>

        <a-range-picker
          v-if="ticketsTypeSelection === 'masiva'"
          v-model:value="danteRangeMassive"
          :value-format="dateFormat"
          :format="[dateFormat, dateFormat]"
        />
      </a-row>
      <a-row class="mt-3">
        <a-col :span="24">
          <tickets-table
            v-if="ticketsTypeSelection === 'individual'"
            type="Modificacion"
          />
          <massive-table
            v-else
            type="Modificacion"
            :dates="danteRangeMassive"
          />
        </a-col>
      </a-row>
    </a-card>

    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="modalVisible"
      title="Nueva solicitud de modificación"
      centered
      :maskClosable="false"
    >
      <template #footer>
        <a-row type="flex" justify="end">
          <a-col>
            <a-space>
              <router-link
                class="justify-content-center d-flex"
                :to="{ name: 'ModificacionIndividual' }"
              >
                <a-button key="1" type="primary">Individual</a-button>
              </router-link>
              <router-link
                class="justify-content-center d-flex"
                :to="{ name: 'ModificacionMasiva' }"
              >
                <a-button key="2" type="primary">Masiva</a-button>
              </router-link>
            </a-space>
          </a-col>
        </a-row>
      </template>
      <a-typography-title class="text-gray-9 fw-regular" :level="3">
        ¿Que tipo de solicitud de modificación deseas crear?
      </a-typography-title>
    </a-modal>
  </div>
  <router-view :key="$route.path"></router-view>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { ref, defineAsyncComponent, onMounted } from 'vue';

import PageHeader from '@/components/page-header.vue';

const MassiveTable = defineAsyncComponent(() =>
  import('@/components/tables/massive-table-test.vue')
);
const TicketsTable = defineAsyncComponent(() =>
  import('@/components/tables/tickets-table-test.vue')
);

import TableResume from '@/components/table-resume.vue';

export default {
  name: 'Modificaciones',
  components: {
    'page-header': PageHeader,
    'table-resume': TableResume,
    'tickets-table': TicketsTable,
    'massive-table': MassiveTable
  },
  setup() {
    // * Route y router
    const route = useRoute();
    const routes = useRouter();

    // * Page Header
    const routesHeader = [
      {
        // path: "first",
        breadcrumbName: 'Modificaciones'
      }
    ];

    // * Modal
    const modalVisible = ref(false);

    const showModal = () => {
      modalVisible.value = true;
    };

    // * Radio group
    const ticketsTypeSelection = ref('');
    ticketsTypeSelection.value = route.hash === '' ? 'individual' : 'masiva';

    const individualRoutes = ref({});
    const massiveRoutes = ref({});

    const onChangeTabs = async (value) => {
      const tabValue = value.target.value;

      if (tabValue === 'masiva') {
        // Guardo los filtros que hice en individual
        individualRoutes.value = route.query;
        // Redireccion
        await routes.replace({
          name: 'Modificaciones',
          query: massiveRoutes.value,
          hash: '#massive'
        });
      } else {
        // Guardo los filtros que hice en individual
        massiveRoutes.value = route.query;
        // Redireccion
        await routes.replace({
          name: 'Modificaciones',
          query: individualRoutes.value
        });
      }

      ticketsTypeSelection.value = tabValue;
    };

    // * Selector de fechas
    const dateFormat = 'YYYY-MM-DD';
    const danteRangeMassive = ref([]);
    // Cuando cargue la página, obtener la fecha y pasarla en el selector
    onMounted(() => {
      if (
        route.query.startDate != undefined &&
        route.query.endDate != undefined
      ) {
        if (route.hash == '#massive') {
          danteRangeMassive.value.push(route.query.startDate);
          danteRangeMassive.value.push(route.query.endDate);
        }
      }
    });

    return {
      routesHeader,
      modalVisible,
      ticketsTypeSelection,
      showModal,
      onChangeTabs,
      dateFormat,
      danteRangeMassive
    };
  }
};
</script>
